import { showNotification } from '@mantine/notifications';
import { Check, X } from 'tabler-icons-react';
import { axiosPrivate } from '../api/axios';
import { AcquirerTypes } from '../enums/acquirer-types.enum';
import { MerchantOnboardingStatusAction } from '../type/admin.types';
import { ErrorResponse } from '../type/error-response.types';
import { UpdateOnboardingStatusRequest } from '../type/onboard-merchant-request.types';

export const updateOnboardingStatus = async (
  request: UpdateOnboardingStatusRequest,
  acquirerColumn?: AcquirerTypes
) => {
  let endpoint = '/web/onboard/status';

  const aub_endpoint = '/web/onboard/aub_status';
  const ub_endpoint = '/web/onboard/ub_status';
  const maya_endpoint = '/web/onboard/maya_status';

  // Use a different endpoint if onboarding's acquirer status is
  // the one being updated
  if (acquirerColumn === AcquirerTypes.AUB) {
    endpoint = aub_endpoint;
  } else if (acquirerColumn === AcquirerTypes.UNIONBANK) {
    endpoint = ub_endpoint;
  } else if (acquirerColumn === AcquirerTypes.MAYA) {
    endpoint = maya_endpoint;
  }

  let message = 'Successfully updated selected merchant/s';

  if (request.onboardingStatus === MerchantOnboardingStatusAction.DECLINE) {
    message = 'Successfully declined selected merchant/s';
  }

  try {
    await axiosPrivate.post(endpoint, request);
    showNotification({
      id: 'successfully-updated-onboarding-status',
      message: message,
      icon: <Check size={16} />,
      color: 'teal',
      autoClose: 6000,
    });
  } catch (err: any) {
    const error: ErrorResponse = err.response?.data;

    showNotification({
      id: 'failed-to-update-onboarding-status',
      message: error.error || 'An Unexpected Error Occurred',
      icon: <X size={16} />,
      color: 'red',
      autoClose: 10000,
    });
    throw err;
  }
};

export const enable = async (merchantIds: number[]) => {
  const endpoint = '/web/onboard/enable';

  try {
    await axiosPrivate.post(endpoint, {
      merchantIds: merchantIds,
    });
    showNotification({
      id: 'successfully-enabled-merchants',
      message: 'Successfully enabled selected merchant/s',
      icon: <Check size={16} />,
      color: 'teal',
      autoClose: 6000,
    });
  } catch (err: any) {
    const error: ErrorResponse = err.response?.data;
    showNotification({
      id: 'failed-to-enable-merchant',
      message: error.error || 'An Unexpected Error Occurred',
      icon: <X size={16} />,
      color: 'red',
      autoClose: 10000,
    });
    throw err;
  }
};

export const disable = async (
  merchantIds: number[],
  disabledReason: string
) => {
  const endpoint = '/web/onboard/disable';

  try {
    await axiosPrivate.post(endpoint, {
      merchantIds: merchantIds,
      disabledReason: disabledReason,
    });
    showNotification({
      id: 'successfully-disabled-merchants',
      message: 'Successfully disabled selected merchant/s',
      icon: <Check size={16} />,
      color: 'teal',
      autoClose: 6000,
    });
  } catch (err: any) {
    const error: ErrorResponse = err.response?.data;
    showNotification({
      id: 'failed-to-disable-merchant',
      message: error.error || 'An Unexpected Error Occurred',
      icon: <X size={16} />,
      color: 'red',
      autoClose: 10000,
    });

    throw err;
  }
};
